import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'contracts';
let baseUrl = config.apiBaseUrl;

export default {
  getAll(where) {
    let whereString = where ? '?where=' + JSON.stringify(where) : '';
    return axios.get(baseUrl + '/' + restModel + whereString, RequestConfig);
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },

  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  }
}
